import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function authAccount(){
    const authAccountResponse = await axios.get(`admin/account/auth`, { withCredentials : true });
    return authAccountResponse?.data;
}

async function login(params,){
    const loginResponse = await axios.post(`admin/account/login`, params, { withCredentials : true });
    return loginResponse?.data;
}

async function verifyOtp(params){
    const verifyResponse = await axios.post(`admin/account/login/verify`, params, { withCredentials : true });
    return verifyResponse?.data;
}

async function logout(){
    const logoutResponse = await axios.post(`admin/account/logout`, {}, { withCredentials : true, });
    return logoutResponse?.data;
}

async function getSessions(){
    const sessionsResponse = await axios.get(`admin/account/sessions`, { withCredentials : true });
    return sessionsResponse?.data;
}

async function revokeSession(session_id){
    const revokeResponse = await axios.delete(`admin/account/session/${session_id}/revoke`, { withCredentials : true });
    return revokeResponse?.data;
}

export default {
    authAccount,
    login,
    verifyOtp,
    logout,
    getSessions,
    revokeSession,
}